import { Component, OnInit, Input } from '@angular/core';
import { FormGroup,FormControl } from '@angular/forms';

declare var tinymce: any;

@Component({
  selector: 'app-tinymce-editor',
  templateUrl: './tinymce-editor.component.html',
  styleUrls: ['./tinymce-editor.component.scss']
})
export class TinymceEditorComponent implements OnInit {

  @Input() id: string;
  @Input() form:FormGroup;

  constructor() { }

  ngOnInit() {
    this.form = new FormGroup({
      ques: new FormControl()
   });
  }

  ngAfterViewInit() {
    tinymce.baseURL = 'assets';
      tinymce.init({
        selector: 'editor#fibtype',
        height: 300,
        // base_url: '/tinymce',
        suffix: '.min',
        themes: "assets/themes/silver",
        // icons: "assets/icons/",
        // content_css: '//www.tiny.cloud/css/codepen.min.css',

        plugins: [
          'advlist autolink lists link image imagetools charmap print preview anchor',
          'searchreplace visualblocks code fullscreen',
          'insertdatetime media table paste code help wordcount'
        ],
        toolbar: 'undo redo | formatselect | bold italic backcolor | \
        customBlankButton | alignleft aligncenter alignright alignjustify | \
        bullist numlist outdent indent | removeformat | \
        link image | preview media help',
        image_title: true,
        automatic_uploads: true,
        image_description: false,        
        file_picker_types: 'file image media',
        // external_plugins: { tiny_mce_wiris: "https://www.wiris.net/demo/plugins/tiny_mce/plugin.js" }, 
        // toolbar1: "tiny_mce_wiris_formulaEditor, tiny_mce_wiris_formulaEditorChemistry",
        file_picker_callback: function (cb, value, meta) {

          var input = document.createElement('input');
          input.setAttribute('type', 'file');
          input.setAttribute('accept', 'image/*');

          // Note: In modern browsers input[type="file"] is functional without 
          // even adding it to the DOM, but that might not be the case in some older
          // or quirky browsers like IE, so you might want to add it to the DOM
          // just in case, and visually hide it. And do not forget do remove it
          // once you do not need it anymore.

          input.onchange = function () {

            // var file = $event.path[0].files[0];
            var file = input.files[0];
            console.log(file)
            var reader: any = new FileReader();

            reader.onload = function () {

              // Note: Now we need to register the blob in TinyMCEs image blob
              // registry. In the next release this part hopefully won't be
              // necessary, as we are looking to handle it internally.
              var id = 'blobid' + (new Date()).getTime();
              var blobCache = tinymce.activeEditor.editorUpload.blobCache;
              var base64 = reader.result.split(',')[1];
              var blobInfo = blobCache.create(id, file, base64);

              blobCache.add(blobInfo);

              // call the callback and populate the Title field with the file name

              cb(reader.result, { title: file.name });
            };
            reader.readAsDataURL(file);
          };

          input.click();
        },
        images_upload_handler: function (blobInfo, success, failure, progress) {
          var xhr, formData;

          xhr = new XMLHttpRequest();
          xhr.withCredentials = false;
          xhr.open('POST', 'https://dev.api.edu-collab.com/upload_files_add_question');
          // xhr.open('POST', that.apiEndpoint+'/upload_files_add_question');
          xhr.setRequestHeader('session-token', localStorage.getItem('token')); // manually set header
          
          xhr.upload.onprogress = function (e) {
            progress(e.loaded / e.total * 100);
          };

          xhr.onerror = function () {
            failure("Image upload failed due to a XHR Transport error. Code: " + xhr.status);
          };

          xhr.onload = function () {
            var json;

            if (xhr.status != 200) {
              failure('HTTP Error: ' + xhr.status);
              return;
            }
            json = JSON.parse(xhr.responseText);

            if (!json || typeof json.file_path != 'string') {
              failure('Invalid JSON: ' + xhr.responseText);
              return;
            }

            success(json.file_path);
          };

          formData = new FormData();
          formData.append('file_path', blobInfo.blob(), blobInfo.filename());

          xhr.send(formData);
        },
        setup: function (editor) {
          editor.ui.registry.addButton('customBlankButton', {
            text: 'Add Blank',
            onAction: function () {
              // editor.windowManager.open(dialogConfig)
            }
          })
        }
      });
  }
}
